import {
  GET_DATA_MEDIA,
  GET_KATEGORI_MEDIA,
  SET_LOADING_DATA_MEDIA,
  SET_LOADING_KATEGORI_MEDIA,
  SET_PAGINATION_DATA_MEDIA,
  SET_PAGINATION_KATEGORI_MEDIA,
} from '../constant';

const initialState = {
  kategori: [],
  loadingKategori: false,
  kategoriPagination: 0,
  totalKategori: 0,
  data: [],
  loadingData: false,
  dataPagination: 0,
  totalData: 0,
};

const mediaReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_KATEGORI_MEDIA: {
      return {
        ...state,
        loadingKategori: action?.payload,
      };
    }
    case SET_PAGINATION_KATEGORI_MEDIA: {
      return {
        ...state,
        kategoriPagination: action?.payload,
      };
    }
    case GET_KATEGORI_MEDIA: {
      return {
        ...state,
        kategori: action?.payload?.data,
        totalKategori: action?.payload?.total,
        loadingKategori: false,
      };
    }
    case SET_LOADING_DATA_MEDIA: {
      return {
        ...state,
        loadingData: action?.payload,
      };
    }
    case SET_PAGINATION_DATA_MEDIA: {
      return {
        ...state,
        dataPagination: action?.payload,
      };
    }
    case GET_DATA_MEDIA: {
      return {
        ...state,
        data: action?.payload?.data || [],
        totalData: action?.payload?.total,
        loadingData: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default mediaReducer;
